import React from "react";
import { Modal } from "@linkfluence/core/modal";
import ModalBlockedProject from "@radarly/components/modals/blocked-project";
import {
  useCurrentUserLocale,
  useCurrentUserTimezone,
} from "@radarly/core/user/use-cases";
import { Project } from "@radarly/models/project";

type openFn = () => void;

const MODAL_BLOCKED_PROJECT = "modalBlockedProject";

interface IProps {
  project: Project;
  onValidate: () => void;
  children: (open: openFn) => JSX.Element;
}

const RadarlyModalBlockedProject = ({
  project,
  children,
  onValidate,
}: IProps) => {
  const { open, close, ModalWrapper } = Modal.get(MODAL_BLOCKED_PROJECT);
  const timezone = useCurrentUserTimezone();
  const locale = useCurrentUserLocale();
  return (
    <>
      {children(open)}
      <ModalWrapper>
        <ModalBlockedProject
          onCancel={() => close()}
          timezone={timezone}
          project={project}
          onValidate={() => {
            onValidate();
            close();
          }}
          locale={locale}
        />
      </ModalWrapper>
    </>
  );
};

export default RadarlyModalBlockedProject;
